import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Select } from "antd";
import getInfoAction from "../../redux/getOrganizationAndRestaurant/actions";
import authActions from "../../redux/auth/actions";
import HeaderUserProfile from "./HeaderComponents/HeaderUserProfile";
import { useProjectState } from "../../context/stateContext";
import logo from "../../assets/images/Logo.png";
import "./index.css";

const { getOrganizations } = getInfoAction;
const { checkAuthorization } = authActions;

function Header({ collapsed }) {
  const { organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const dispatch = useDispatch();
  const { selectedOrganization, setSelectedOrganization } = useProjectState();

  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      window.location.reload();
    } else {
      didMount.current = true;
    }
  }, [selectedOrganization]);

  useEffect(() => {
    dispatch(checkAuthorization());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (localStorage.getItem("id_token") !== null) {
      dispatch(getOrganizations());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleOrganizationChange = (e, v) => {
    setSelectedOrganization(v.key);
    window.localStorage.setItem("organizationId", v.key);
    localStorage.setItem("displayName", v.value);
    localStorage.setItem("organization", v.displayNameBulgarian);
    localStorage.setItem(
      "restaurantId",

      organizations.filter((o) => parseInt(o.id) === v.key)[0][
        "defaultTouchSaleRestaurantId"
      ]
    );
    return false;
  };

  const displayOrganizationsInSelect = organizations.map(function (obj) {
    obj["key"] = obj["id"];
    obj["value"] = obj["displayNameBulgarian"];

    return obj;
  });

  return (
    <div>
      <Layout id="header-style">
        <div className="header-sidebar-logo">
          <img src={logo} alt="background" width="30px" />
        </div>
        <div>
          {localStorage.getItem("status") === "true" && (
            <Select
              showSearch
              listHeight={500}
              placeholder="Изберете организация"
              filterOption={(input, option) =>
                (option?.displayNameBulgarian.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              value={
                organizations?.filter(
                  (o) =>
                    o.id === parseInt(localStorage.getItem("organizationId"))
                )[0]?.displayNameBulgarian
              }
              onChange={(e, v) => handleOrganizationChange(e, v)}
              style={{
                width: window.innerWidth > 760 ? 500 : 200,
                textAlign: "center",
              }}
              options={displayOrganizationsInSelect}
            />
          )}
        </div>
        <div className="header-user-profile">
          <HeaderUserProfile />
        </div>
      </Layout>
    </div>
  );
}

export default Header;
